module.exports = __webpack_public_path__ + "img/kongapp.0a39e17f.png";